 <template>
  <v-app>
    <Navigations :breadcrumbs="this.breadcrumb" />
    <v-main>
      <v-container>
        <v-spacer class="py-5"></v-spacer>
        <v-row>
          <v-col col="12" md="6" class="kyano-responsive-col-width">
            <v-card elevation="0" outlined class="kyano-responsive-card-width">
              <v-img
                src="../../assets/illustrations/places.svg"
                class="my-5"
              ></v-img>
              <DialogCompanyname :data="companies" />
              <DialogAbout :data="companies" />
              <v-divider></v-divider>
              <v-spacer class="py-3"></v-spacer>
              <DialogAdress :data="companies" />
              <v-spacer class="py-3"></v-spacer>
              <DialogEmail :data="companies" />
              <DialogSite :data="companies" />
              <DialogPhone :data="companies" />
              <v-spacer class="py-3"></v-spacer>
              <DialogVatno :data="companies" />
              <DialogIban :data="companies" />
              <DialogKvk :data="companies" />
            </v-card>
          </v-col>
          <v-col col="12" md="6">
            <v-card elevation="0" class="rounded-lg mb-5 pa-4">
              <h3>
                Deze bedrijfgegevens worden getoond op de gekoppelde Kyano
                Cards.
              </h3>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import DialogCompanyname from "@/components/companies/DialogCompanyname.vue";
import DialogAbout from "@/components/companies/DialogAbout.vue";
import DialogAdress from "@/components/companies/DialogAdress.vue";
import DialogEmail from "@/components/companies/DialogEmail.vue";
import DialogPhone from "@/components/companies/DialogPhone.vue";
import DialogVatno from "@/components/companies/DialogVatno.vue";
import DialogIban from "@/components/companies/DialogIban.vue";
import DialogKvk from "@/components/companies/DialogKvk.vue";
import DialogSite from "@/components/companies/DialogSite.vue";

import Navigations from "@/components/Navigations.vue";

export default {
  components: {
    Navigations,
    DialogAdress,
    DialogEmail,
    DialogPhone,
    DialogVatno,
    DialogCompanyname,
    DialogAbout,
    DialogIban,
    DialogKvk,
    DialogSite,
  },

  data: () => ({
    companies: {
      //Companyname
      dialogcompanyname: false,
      companyname: "Finalfilm",

      dialogabout: false,
      about: "Wij zijn een bedrijf dat mooie producten ontwikkeld.",
      //Adress
      dialogadress: false,
      adres1: "moermanskweg 2-22",
      adres2: "adres2",
      postcode: "9723HM",
      location_state: "Groningen",
      country: "Nederland",

      //Contact details
      dialogphone: false,
      phonenumber: "0852345678",
      dialogesite: false,
      website: "https://snelwebcenter.nl",
      dialogemail: false,
      emailadres: "info@swc.nl",
      //Compnaydetails
      dialogvat: false,
      vat_no: "NL231234349",
      dialogiban: false,
      iban: "NL89INGB123456789",
      dialogkvk: false,
      kvk_no: "123345666",
    },
  }),
};
</script>
<style>
/* v-card responsive full width */

.kyano-responsive-card-width {
  border-radius: 8px;
  border: 1px solid #e5e5ea;
  margin-bottom: 20px;
  padding: 20px;
}

@media (max-width: 575.98px) {
  .kyano-responsive-col-width {
    padding: 0px !important;
    background: #f5f5f9;
  }
  .kyano-responsive-card-width {
    border: none;
    border-radius: 0px !important;
  }
}
</style>